import { useEffect } from "react";
import styles from './Privacy.module.css';

const Privacy = () => {
	useEffect(() => {
        document.title = 'Privacy';
    }, []);

	return (
		<div className={styles.container}>
			<div className={styles.subheader}>
				PRIVACY POLICY
			</div>
			<div className={styles.paragraph}>
				This privacy policy has been compiled to better serve those who are concerned with
				how their 'Personally identifiable information' (PII) may be collected or used online by
				PYC Giving Foundation (“PYC”).
			</div>
			<div className={styles.paragraph}>
				Please read our privacy policy carefully to get a clear understanding of how we collect,
				use, protect or otherwise handle your Personally Identifiable Information in accordance
				with our website and mobile applications.
			</div>
			<div className={styles.subheader}>
				INFORMATION COLLECTION
			</div>
			<div className={styles.italicParagraph}>
				What personal information do we collect from the people that visit our blog, website or app?
			</div>
			<div className={styles.paragraph}>
				When registering on our site, as appropriate, you may be asked to enter your name,
				email address or other details to help you with your experience.
			</div>
			<div className={styles.paragraph}>
				'Other details' for our application includes affiliations to high schools, universities and
				other organizations considered to be networks for the purpose of our application.
			</div>
			<div className={styles.italicParagraph}>
				When do we collect information?
			</div>
			<div className={styles.paragraph}>
				We collect information from you when you enter information on our site or mobile application.
			</div>
			<div className={styles.paragraph}>
				We collect information when you allow permission for access to resources on your
				device for use by the application such as taking photos with the camera within the
				application.
			</div>
			<div className={styles.paragraph}>
				We collect information when you register your account using an external account for
				authentication giving to access profile information associated with that third party
				account.
			</div>
			<div className={styles.subheader}>
				INFORMATION USAGE
			</div>
			<div className={styles.italicParagraph}>
				How do we use your information?
			</div>
			<div className={styles.paragraph}>
				We may use the information we collect from you when you register, make a purchase,
				sign up for our newsletter, respond to a survey or marketing communication, surf the
				website, or use certain other site features in the following ways:
				<ul>
					<li>
						To personalize user's experience and to allow us to deliver the type of content
						and product offerings in which you are most interested relating to the
						application's scope and purpose.
					</li>
				</ul>
			</div>
			<div className={styles.subheader}>
				INFORMATION PROTECTION
			</div>
			<div className={styles.italicParagraph}>
				How do we use your information?
			</div>
			<div className={styles.paragraph}>
				<ul>
					<li>
						We do not use vulnerability scanning and/or scanning to PCI standards.
					</li>
					<li>
						We do not use Malware Scanning.
					</li>
				</ul>
			</div>
			<div className={styles.subheader}>
				COOKIE USAGE
			</div>
			<div className={styles.italicParagraph}>
				Do we use 'cookies'?
			</div>
			<div className={styles.paragraph}>
				Yes. Cookies are small files that a site or its service provider transfers to your
				computer's hard drive through your Web browser (if you allow) that enables the site's or
				service provider's systems to recognize your browser and capture and remember
				certain information. They are also used to help us understand your preferences based
				on previous or current site activity, which enables us to provide you with improved
				services. We also use cookies to help us compile aggregate data about site traffic and
				site interaction so that we can offer better site experiences and tools in the future.
			</div>
			<div className={styles.paragraph}>
				We use cookies to:
				<ul>
					<li>
						Understand and save user's preferences for future visits.
					</li>
					<li>
						Compile aggregate data about site traffic and site interactions in order to offer
						better site experiences and tools in the future. We may also use trusted third
						party services that track this information on our behalf.
					</li>
				</ul>
			</div>
			<div className={styles.paragraph}>
				You can choose to have your computer warn you each time a cookie is being sent, or
				you can choose to turn off all cookies. You do this through your browser (like Internet
				Explorer) settings. Each browser is a little different, so look at your browser's Help menu
				to learn the correct way to modify your cookies. If you disable cookies off,
				some features will be disabled It won't affect the users experience that make your site
				experience more efficient and some of our services will not function properly.
			</div>
			<div className={styles.subheader}>
				DATA DELETION
			</div>
			<div className={styles.paragraph}>
				You have the right to request that PYC delete your Personal Information that we
				collected from you and retained, subject to certain exceptions. Once we receive and
				confirm your verifiable consumer request, we will delete (and direct our service
				providers to delete) your Personal Information from our records, unless certain
				exceptions apply.
			</div>
			<div className={styles.italicParagraph}>
				Requesting Data Deletion
			</div>
			<div className={styles.paragraph}>
				To exercise the access and deletion rights described above, please submit a verifiable
				consumer request to us by emailing us at <a href="mailto:hello@pycfoundation.org">hello@pycfoundation.org</a>.
			</div>
			<div className={styles.paragraph}>
				Only you, or a person that you authorize to act on your behalf, may make a verifiable
				consumer request related to your Personal Information. You may also make a verifiable
				consumer request on behalf of your minor child. You may only make a verifiable
				consumer request for access twice within a 12-month period. The verifiable consumer
				request must:
				<ul>
					<li>
						Provide sufficient information that allows us to reasonably verify you are the person
						about whom we collected Personal Information or an authorized representative.
					</li>
					<li>
						Describe your request with sufficient detail that allows us to properly understand,
						evaluate, and respond to it.
					</li>
				</ul>
			</div>
			<div className={styles.subheader}>
				3RD PARTY DISCLOSURE
			</div>
			<div className={styles.paragraph}>
				We do not sell, trade, or otherwise transfer to outside parties your personally identifiable
				information.
			</div>
			<div className={styles.subheader}>
				3RD PARTY LINKS
			</div>
			<div className={styles.paragraph}>
				A third party link is defined as a link to a website that we do not own and control. We
				take moderation and quality control seriously for any issue that may arise with third
				party links. However, this Privacy Policy does not cover any access made by users to
				Third Party Links from our website or mobile applications and entities access from these
				links may have a different privacy policy.
			</div>
			<div className={styles.subheader}>
				CALIFORNIA ONLINE PRIVACY PROTECTION ACT
			</div>
			<div className={styles.paragraph}>
				CalOPPA is the first state law in the nation to require commercial websites and online
				services to post a privacy policy. The law's reach stretches well beyond California to
				require a person or company in the United States (and conceivably the world) that
				operates websites collecting personally identifiable information from California
				consumers to post a conspicuous privacy policy on its website stating exactly the
				information being collected and those individuals with whom it is being shared, and to
				comply with this policy.
			</div>
			<div className={styles.paragraph}>
				See more at: <a href="http://consumercal.org/california-online-privacy-
				protection-act-caloppa/#sthash.0FdRbT51.dpuf" target="_blank" rel="noreferrer">http://consumercal.org/california-online-privacy-
				protection-act-caloppa/#sthash.0FdRbT51.dpuf</a>
			</div>
			<div className={styles.paragraph}>
				According to CalOPPA we agree to the following:
				<ul>
					<li>
						Users can visit our site anonymously
					</li>
					<li>
						Once this privacy policy is created, we will add a link to it on our home page, or
						as a minimum on the first significant page after entering our website.
					</li>
					<li>
						Our Privacy Policy link includes the word 'Privacy', and can be easily be found on
						the page specified above.
					</li>
				</ul>
			</div>
			<div className={styles.paragraph}>
				Users will be notified of any privacy policy changes:
				<ul>
					<li>
						On our Privacy Policy Page
					</li>
				</ul>
			</div>
			<div className={styles.paragraph}>
				Users are able to change their personal information:
				<ul>
					<li>
						By emailing us
					</li>
					<li>
						By logging in to their account
					</li>
				</ul>
			</div>
			<div className={styles.italicParagraph}>
				How does our site handle do not track signals?
			</div>
			<div className={styles.paragraph}>
				We honor do not track signals and do not track, plant cookies, or use advertising when
				a Do Not Track (DNT) browser mechanism is in place.
			</div>
			<div className={styles.italicParagraph}>
				Does our site allow third party behavioral tracking?
			</div>
			<div className={styles.paragraph}>
				It's also important to note that we do not allow third party behavioral tracking
			</div>
			<div className={styles.subheader}>
				COPPA
			</div>
			<div className={styles.paragraph}>
				When it comes to the collection of personal information from children under 13, the
				Children's Online Privacy Protection Act (COPPA) puts parents in control. The Federal
				Trade Commission, the nation's consumer protection agency, enforces the COPPA
				Rule, which spells out what operators of websites and online services must do to protect
				children's privacy and safety online. We do not specifically market to children under 13.
			</div>
			<div className={styles.subheader}>
				CAN-SPAM
			</div>
			<div className={styles.paragraph}>
				The CAN-SPAM Act is a law that sets the rules for commercial email, establishes
				requirements for commercial messages, gives recipients the right to have emails
				stopped from being sent to them, and spells out tough penalties for violations.
			</div>
			<div className={styles.paragraph}>
				We collect your email address in order to:
				<ul>
					<li>
						Send information, respond to inquiries, and/or other requests or questions.
					</li>
					<li>
						Market to our mailing list or continue to send emails to our clients after the
						original transaction has occurred
					</li>
				</ul>
			</div>
			<div className={styles.paragraph}>
				To be in accordance with CANSPAM, we agree to the following:
				<ul>
					<li>
						NOT use false, or misleading subjects or email addresses
					</li>
					<li>
						Identify the message as an advertisement in some reasonable way
					</li>
					<li>
						Include the physical address of our business or site headquarters
					</li>
					<li>
						Monitor third party email marketing services for compliance, if one is used.
					</li>
					<li>
						Honor opt-out/unsubscribe requests quickly
					</li>
					<li>
						Allow users to unsubscribe by using the link at the bottom of each email
					</li>
				</ul>
			</div>
			<div className={styles.paragraph}>
				If at any time you would like to unsubscribe from receiving future emails, you can email
				us at <a href="mailto:hello@pycfoundation.org">hello@pycfoundation.org</a>
			</div>
		</div>
	)
};

export default Privacy;